/** Landing screener view phases (design handoff). */
export type ScreenPhase = 'input' | 'scanning' | 'results';

/** Keep scanning legible even when the API is fast. Skipped in Jest. */
export const MIN_SCAN_MS = process.env.NODE_ENV === 'test' ? 0 : 2100;

export function sleep(ms: number): Promise<void> {
  return new Promise((resolve) => setTimeout(resolve, ms));
}
